import { render } from "./ReportPage.vue?vue&type=template&id=2b719900"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__